import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { DEVICE_GATEWAY } from '../../services/DeviceGateway';
import { DeviceActions } from '../actions/device.actions';
import { SiteDevicesActions } from '../actions/site-devices.actions';

@Injectable()
export class DeviceDetailEffects {
    private readonly actions$ = inject(Actions);
    private readonly deviceGateway = inject(DEVICE_GATEWAY);

    loadDevice$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeviceActions.deviceSelected),
            filter(({ deviceId }) => deviceId != null),
            switchMap(({ deviceId }) =>
                this.deviceGateway
                    .fetchDevice(deviceId)
                    .pipe(
                        switchMap((device) =>
                            device
                                ? of(DeviceActions.deviceApiRequestSuccess({ device }))
                                : of(DeviceActions.deviceNotFound({ deviceId })),
                        ),
                    ),
            ),
        ),
    );

    loadUiProfile$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeviceActions.deviceApiRequestSuccess),
            filter(({ device }) => device != null),
            switchMap(({ device }) =>
                this.deviceGateway
                    .getDeviceUI(device.profileId)
                    .pipe(map((uiProfile) => DeviceActions.deviceLoaded({ uiProfile, device }))),
            ),
        ),
    );

    updateSiteDevice$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeviceActions.deviceLoaded),
            filter(({ device }) => device != null),
            map(({ device }) =>
                SiteDevicesActions.deviceUpdated({ siteId: device.rawData.site_id, device: device.rawData }),
            ),
        ),
    );
}
